<div class="relative flex-shrink-0 w-72 h-96 max-w-sm bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col">
  <!-- Card top -->
  <div [routerLink]="['/app/shop', this.shop.shopNumber]"
       (click)="sendRecommendationClickEvent()"
       class="w-full aspect-w-4 aspect-h-3 cursor-pointer">

    <img [src]="shop.mainImageUrl | cdn: 'm'"
         class="object-cover w-full h-full"
         loading="lazy"
         alt="{{ shop.shopName }}"
    />

    <app-image-banner [bannerType]="bannerType" class="absolute top-2"></app-image-banner>
  </div>

  <!-- Card bottom -->
  <div class="flex flex-col flex-1 p-3 space-y-1">
    <div class="flex flex-col gap-1 flex-grow">
      <!-- Shop Name -->
      <p class="text-base font-semibold line-clamp-1 leading-snug tracking-normal text-blue-gray-900 overflow-hidden break-words cursor-pointer"
         [routerLink]="['/app/shop', this.shop.shopNumber]"
         (click)="sendRecommendationClickEvent()">
        {{ shop.shopI18n?.name }}
      </p>

      <!-- Shop Info -->
      <div class="grid grid-cols-3 text-gray-600 text-xs md:text-sm">
        <!-- Location -->
        <div class="flex flex-col gap-1">
          <span>{{ "shopViewPage.location" | transloco }}</span>
          <span class="font-medium text-gray-800 flex flex-row">
            <svg class="h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
              <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13
                   c0-3.87-3.13-7-7-7zm0 9.5c-1.38
                   0-2.5-1.12-2.5-2.5s1.12-2.5
                   2.5-2.5 2.5 1.12 2.5
                   2.5S13.38 11.5 12 11.5z"
              />
            </svg>

            {{ shop.city }}
          </span>
        </div>

        <!-- Average Price -->
        <div class="flex flex-col gap-1">
          <span>{{ "chatbot.shopCard.from" | transloco }}</span>
          <span class="flex flex-row">
            <i class="bi bi-cash me-1"></i>
            <span class="font-medium text-gray-800">
              {{ shop.averagePrice | currencyConverter | async }}
            </span>
          </span>
        </div>

        <!-- Rating -->
        <div class="flex flex-col gap-1">
          <span>
            {{ "shopViewPage.rating" | transloco }}
            <i class="bi bi-info-circle" [ngbTooltip]="'shopCard.ratingToolTip' | transloco"></i>
          </span>

          <span class="flex items-center gap-0.5 leading-relaxed text-xs md:text-base font-medium antialiased text-red-600">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                class="-mt-0.5 h-4 w-4 md:h-5 md:w-5 text-tm-red">
              <path
                  fill-rule="evenodd"
                  d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                  clip-rule="evenodd"></path>
            </svg>

            <!-- Numerical Rating -->
            @if (shop.rating && shop.rating > 0) {
              {{ shop.rating | ratingDecimal }}
            }

            @else {
              <span class="text-gray-400">-</span>
            }

          </span>
        </div>
      </div>

      <!-- Booking Button -->
      <button [routerLink]="['/app/shop', this.shop.shopNumber]"
              (click)="sendRecommendationClickEvent()"

              class="absolute bottom-2 self-end bg-red-600 hover:bg-red-700
                    text-white text-sm font-medium px-4 py-2 rounded-full
                    float-end cursor-pointer">

        {{ "chatbot.bookNow" | transloco }}
      </button>
    </div>
  </div>
</div>

<ng-template #t let-fill="fill">
  <i class="bi bi-star-fill">
    @if (fill > 0) {
      <i class="bi-star-fill filled" [style.width.%]="fill"></i>
    }
  </i>
</ng-template>
